export const apartmentsViewEvents = {
    UPDATE_ALIAS: 'apartments-view::updateAlias',
    ALIAS_CHANGED: 'apartments-view::aliasChanged',
};
